<template>
  <div>
    <h1 class="page-header">{{ $t('supplier.supplier') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'supplier-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.supplier_code }}</td>
          <td class="kh-font">{{ record.supplier_name_kh }}</td>
          <td>{{ record.supplier_name_en }}</td>
          <td>{{ record.contact_phone_number }}</td>
          <td class="text-center">{{ record.credit_day }}</td>
          <td class="text-center">{{ record.credit_amount }}</td>
          <td>{{ record.supplier_email }}</td>
          <td>{{ record.supplier_address }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'supplier',
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('supplier.code') },
        { name: this.$t('supplier.nameKH') },
        { name: this.$t('supplier.nameEN') },
        { name: this.$t('supplier.phone') },
        { name: this.$t('supplier.creditDay'), style: 'text-align:center' },
        { name: this.$t('supplier.amount'), style: 'text-align:center' },
        { name: this.$t('supplier.email') },
        { name: this.$t('supplier.address') },
        {
          name: this.$t('supplier.actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('supplier', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.supplier.search
      },
      set(newValue) {
        this.$store.commit('supplier/SET_SEARCH', newValue)
        this.$store.commit('supplier/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('supplier/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('supplier/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'supplier-edit',
        params: { id: record.supplier_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('supplier/destroy', record.supplier_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'supplier-create') {
      this.$store.commit('supplier/RESET_STATE')
    }
    next()
  }
}
</script>
